import { ReactNode, useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import styles from "./styles.module.scss";

interface StoreFaqProps {
  formHref: string;
}

const faqs: { question: string; answer: ReactNode }[] = [
  {
    question: "Posso parar de usar os produtos depois do tratamento?",
    answer: <>
      <p>Se a sua queda é contínua (por exemplo, alopecia androgenética), normalmente é necessário manutenção. Interromper a maioria das terapias ativas leva à perda gradual dos ganhos.</p>
      <p><strong>O que acontece se eu parar…</strong></p>
      <ul>
        <li><strong>Finasterida/Dutasterida:</strong> o DHT volta a subir; as melhoras costumam desaparecer em 6 a 12 meses. Converse com seu médico antes de interromper.</li>
        <li><strong>Minoxidil (oral/tópico):</strong> a estimulação dos folículos termina; a queda costuma começar em 2 a 3 meses, com retorno ao quadro inicial em 3 a 6 meses.</li>
        <li><strong>Laser Cap (LLLT):</strong> os resultados dependem do uso; pausas de semanas desaceleram o progresso, e pausas mais longas podem reverter os ganhos.</li>
        <li><strong>Shampoo / Condicionador Trichoscience com Cetoconazol:</strong> você pode reduzir a frequência; se a caspa ou a inflamação voltarem, retome o uso.</li>
        <li><strong>Suplemento Vitruvian Line:</strong> é um complemento; pode ser interrompido com segurança (sem efeito rebote), mas você perde o reforço nutricional.</li>
        <li><strong>Sea Salt Spray:</strong> apenas para finalização — pode parar a qualquer momento, sem efeito no crescimento.</li>
      </ul>
    </>,
  },
  {
    question: "Como acompanho meu pedido?",
    answer: <p>Após a conclusão do pedido, nossa equipe enviará o seu produto. Assim que a transportadora receber o pacote, você receberá um e-mail com as informações de rastreamento.</p>,
  },
  {
    question: "Existem efeitos colaterais?",
    answer: <>
      <p>Resposta curta: a maioria das pessoas tolera bem — apenas cerca de 2% apresentam efeitos —, mas eles podem ocorrer. Costumam ser leves e reversíveis, especialmente com a finasterida; a dutasterida pode permanecer mais tempo no organismo.</p>
      <p><strong>Os efeitos colaterais podem incluir:</strong></p>
      <ul>
        <li>Redução da libido, dificuldade de ereção ou redução do volume ejaculado</li>
        <li>Sensibilidade/aumento das mamas (ginecomastia), desconforto testicular</li>
        <li>Dor de cabeça, tontura, erupções na pele</li>
      </ul>
      <p><strong>Raros</strong></p>
      <ul>
        <li>Alterações de humor (desânimo, ansiedade), diminuição da energia</li>
        <li>Reação alérgica (inchaço, urticária — procure atendimento de urgência)</li>
        <li>Alterações nas enzimas do fígado (raro; converse com seu médico se tiver doença hepática)</li>
      </ul>
      <p><strong>Observações importantes</strong></p>
      <ul>
        <li><strong>Exames de PSA:</strong> ambos os medicamentos reduzem o PSA (~50%); os médicos ajustam os resultados.</li>
        <li><strong>Gravidez:</strong> não indicado para mulheres grávidas ou que possam engravidar. Evite manusear comprimidos partidos/esmagados ou cápsulas vazando.</li>
        <li><strong>Persistência:</strong> os efeitos desaparecem após a interrupção; a dutasterida pode levar meses para ser eliminada (meia-vida muito longa). Sintomas persistentes são incomuns, mas já foram relatados — informe seu médico se algo continuar.</li>
      </ul>
      <p>Se notar alterações sexuais, de humor ou nas mamas, ou qualquer coisa que o preocupe, procure seu médico imediatamente. Vamos ajudar a pesar benefícios e riscos e ajustar o plano, se necessário.</p>
    </>,
  },
  {
    question: "Posso usar minoxidil e finasterida/dutasterida ao mesmo tempo?",
    answer: <p>Eles agem por mecanismos diferentes: o minoxidil estimula os folículos e a finasterida/dutasterida reduzem o DHT. Por isso, usá-los juntos é comum e mais eficaz do que qualquer um isoladamente.</p>,
  },
  {
    question: "Os produtos são seguros para todos os tipos de cabelo?",
    answer: <p>Sim, nossa linha foi desenvolvida para ser segura e eficaz para todas as cores e tipos de cabelo.</p>,
  },
  {
    question: "Quanto tempo leva para ver resultados?",
    answer: <p>Os resultados variam de acordo com o seu tratamento e a forma como seu organismo responde a ele, mas a maioria das pessoas vê resultados visíveis entre 3 e 6 meses.</p>,
  },
  {
    question: "Qual é a diferença entre minoxidil e dutasterida?",
    answer: <p>A dutasterida e a finasterida são bloqueadores de DHT, que inibem a produção de DHT, enquanto o minoxidil é um vasodilatador que aumenta o fluxo sanguíneo no couro cabeludo, ajudando a levar nutrientes importantes ao folículo capilar.</p>,
  },
  {
    question: "Como devo tomar o suplemento para interromper a queda?",
    answer: <>
      <p><strong>Finasterida (oral)</strong></p>
      <ul>
        <li><strong>Dose:</strong> 1 mg uma vez ao dia (conforme prescrição).</li>
        <li><strong>Água:</strong> engula inteiro com um copo cheio; pode ser com ou sem alimento.</li>
      </ul>
      <p><strong>Dutasterida (oral)</strong></p>
      <ul>
        <li><strong>Dose:</strong> 0,5 mg uma vez ao dia (conforme prescrição).</li>
        <li><strong>Água:</strong> engula a cápsula inteira com um copo cheio; não esmague nem mastigue.</li>
      </ul>
      <p><strong>Minoxidil</strong></p>
      <ul>
        <li><strong>Dose oral:</strong> conforme prescrição (geralmente 1,25–2,5 mg uma vez ao dia).</li>
        <li><strong>Água (oral):</strong> tome com um copo cheio de água.</li>
        <li><strong>Dose tópica:</strong> 1 mL da solução a 5% (homens: 2×/dia; mulheres: 1×/dia) ou espuma a 5% conforme a bula.</li>
        <li><strong>Água (tópico):</strong> não se aplica — aplique no couro cabeludo limpo e seco.</li>
      </ul>
      <p><strong>Vitruvian Line (suplemento)</strong></p>
      <ul>
        <li><strong>Dose:</strong> 1 cápsula uma vez ao dia.</li>
        <li><strong>Água:</strong> tome com um copo cheio, de preferência junto a uma refeição.</li>
      </ul>
    </>,
  },
];

export function StoreFaq({ formHref }: StoreFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className={styles.section} aria-labelledby="store-faq-title">
      <div className={styles.inner}>
        <div className={styles.heading}>
          <span className={styles.eyebrow}>FAQS</span>
          <h2 className={styles.title} id="store-faq-title">Perguntas frequentes</h2>
        </div>

        <aside className={styles.support}>
          <h3>Oi, tudo bem?</h3>
          <p>Se ainda tiver alguma dúvida, nossos especialistas estão disponíveis para ajudar.</p>
          <a href={formHref}>Tire suas dúvidas</a>
        </aside>

        <div className={styles.list}>
          {faqs.map((faq, index) => {
            const isExpanded = openIndex === index;
            const panelId = `store-faq-panel-${index}`;
            const buttonId = `store-faq-btn-${index}`;
            return (
              <article className={styles.item} key={faq.question}>
                <h3>
                  <button
                    className={styles.trigger}
                    id={buttonId}
                    type="button"
                    aria-expanded={isExpanded}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isExpanded ? null : index)}
                  >
                    <span>{faq.question}</span>
                    <IconChevronDown className={styles.chevron} size={14} aria-hidden="true" />
                  </button>
                </h3>
                <div className={styles.panel} id={panelId} role="region" aria-labelledby={buttonId} hidden={!isExpanded}>
                  {faq.answer}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
